import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="quotes-form"
export default class extends Controller {
  static targets = ['visaClass', 'visaClassError'];

  connect() {
  }

  canSubmit(event) {
    if (this.hasVisaClassTarget && !this.visaClassTarget.value) {
      event.preventDefault();
      this.showVisaClassError();
      return false;
    }

    this.hideVisaClassError();
    this.element.querySelector('input[type=submit]').removeAttribute('disabled');
    return true;
  }

  showVisaClassError() {
    if (this.hasVisaClassErrorTarget) {
      this.visaClassErrorTarget.style.display = 'block';
    }
    if (this.hasVisaClassTarget) {
      this.visaClassTarget.style.borderColor = 'red';
      this.visaClassTarget.style.borderWidth = '2px';
    }
  }

  hideVisaClassError() {
    if (this.hasVisaClassErrorTarget) {
      this.visaClassErrorTarget.style.display = 'none';
    }
    if (this.hasVisaClassTarget) {
      this.visaClassTarget.style.borderColor = '';
      this.visaClassTarget.style.borderWidth = '';
    }
  }
}
